export const SitePrimaryButton = {
  border: '2px solid #fff',
  fontWeight: '700',
  minWidth: '130px',
  background: 'none'
};
